import script from "./goRinSyo0018.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0018.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0018.vue?vue&type=style&index=0&id=13e0d6f5&lang=scss"

const __exports__ = script;

export default __exports__